<template>
  <div>
    <div class="title-bar">
      <h1>{{ isUpdate ? 'Редактировать баннер бегущей строки' : 'Добавить баннер для бегущей строки' }}</h1>

      <div class="title-bar__button-wrapper">
        <router-link class="button-wrapper-link" :to="{name: 'RunningLinesList'}">
          <el-button type="info">
            <i class="fas fa-list" /> Список
          </el-button>
        </router-link>

        <el-button type="primary" @click="$refs.form.onSubmit()">
          Сохранить
        </el-button>
      </div>
    </div>

    <div class="panel">
      <div class="panel-body">
        <Form ref="form" />
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/components/running-line/Form'

export default {
  name: 'CreateUpdateRunningLinePage',
  metaInfo: {
    title: 'Создать/Редактировать бегущую строку',
  },
  components: {Form},
  computed: {
    isUpdate() {
      return this.$route.name === 'UpdateRunningLine'
    },
  },
}
</script>

<style lang="sass" scoped>
.running-line-form
  padding: 20px

.running-line-form__form
  max-width: 600px
  margin: 0 auto

.running-line-form__upload-image
  margin-bottom: 10px

.running-line-form__preview
  max-width: 200px
  max-height: 200px
  object-fit: contain
</style>



